import { registerPlugin } from '@capacitor/core';
const Posthog = registerPlugin('Posthog', {
    web: () => import('./web').then(m => new m.PosthogWeb()),
});
export * from './definitions';
export { Posthog };
//# sourceMappingURL=index.js.map